import { SvelteComponent, init, safe_not_equal, create_component, mount_component, transition_in, transition_out, destroy_component, component_subscribe, space, insert, detach, text, noop, element, attr, append, group_outros, check_outros, empty } from '../../external_node_modules/svelte/internal/index.mjs.js';
import { t } from '../../i18n.js';
import purchaseTwoFactor, { toogleVisibilityConfirmPurchasePopup } from '../../store/purchaseTwoFactor.js';
import tsv from '../../store/tsv.js';
import Popup from '../shared/components/Popup/Popup.svelte.js';
import PopupBody from '../shared/components/Popup/PopupBody.svelte.js';
import PopupHeader from '../shared/components/Popup/PopupHeader.svelte.js';
import { TSV_ACCOUNT_STATUSES } from '../../constants/web/tsvAccountStatuses.js';
import TwoFactorEnabled from './TwoFactorEnabled.svelte.js';
import TwoFactorDisabled from './TwoFactorDisabled.svelte.js';
import ThreeDS from './ThreeDS.svelte.js';
import { setLoading } from '../../store/isLoading.js';
import './ConfirmPurchase.css.js';

/* src/ui/PurchaseProduct/ConfirmPurchase.svelte generated by Svelte v3.44.2 */

function create_default_slot_2(ctx) {
	let t_1_value = t('Защита платежной операции') + "";
	let t_1;

	return {
		c() {
			t_1 = text(t_1_value);
		},
		m(target, anchor) {
			insert(target, t_1, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t_1);
		}
	};
}

// (33:45) 
function create_if_block_2(ctx) {
	let threeds;
	let current;
	threeds = new ThreeDS({});

	return {
		c() {
			create_component(threeds.$$.fragment);
		},
		m(target, anchor) {
			mount_component(threeds, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(threeds.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(threeds.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(threeds, detaching);
		}
	};
}

// (27:6) {#if $purchaseTwoFactor.isTwoFactor}
function create_if_block(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_1, create_else_block];
	const if_blocks = [];

	function select_block_type_1(ctx, dirty) {
		if (/*$tsv*/ ctx[1].accountStatus === TSV_ACCOUNT_STATUSES.ENABLED) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_1(ctx);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_1(ctx);

			if (current_block_type_index !== previous_block_index) {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (30:8) {:else}
function create_else_block(ctx) {
	let twofactordisabled;
	let current;
	twofactordisabled = new TwoFactorDisabled({});

	return {
		c() {
			create_component(twofactordisabled.$$.fragment);
		},
		m(target, anchor) {
			mount_component(twofactordisabled, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(twofactordisabled.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(twofactordisabled.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(twofactordisabled, detaching);
		}
	};
}

// (28:8) {#if $tsv.accountStatus === TSV_ACCOUNT_STATUSES.ENABLED}
function create_if_block_1(ctx) {
	let twofactorenabled;
	let current;
	twofactorenabled = new TwoFactorEnabled({});

	return {
		c() {
			create_component(twofactorenabled.$$.fragment);
		},
		m(target, anchor) {
			mount_component(twofactorenabled, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(twofactorenabled.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(twofactorenabled.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(twofactorenabled, detaching);
		}
	};
}

// (24:2) <PopupBody>
function create_default_slot_1(ctx) {
	let div1;
	let div0;
	let t_1;
	let current_block_type_index;
	let if_block;
	let current;
	const if_block_creators = [create_if_block, create_if_block_2];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*$purchaseTwoFactor*/ ctx[0].isTwoFactor) return 0;
		if (/*$purchaseTwoFactor*/ ctx[0].isThreeDS) return 1;
		return -1;
	}

	if (~(current_block_type_index = select_block_type(ctx))) {
		if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	}

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			t_1 = space();
			if (if_block) if_block.c();
			attr(div0, "class", "secure-image wcl-79jvvd");
			attr(div1, "class", "secure-overlay wcl-79jvvd");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			append(div1, t_1);

			if (~current_block_type_index) {
				if_blocks[current_block_type_index].m(div1, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx);

			if (current_block_type_index === previous_block_index) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				}
			} else {
				if (if_block) {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
				}

				if (~current_block_type_index) {
					if_block = if_blocks[current_block_type_index];

					if (!if_block) {
						if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block.c();
					} else {
						if_block.p(ctx, dirty);
					}

					transition_in(if_block, 1);
					if_block.m(div1, null);
				} else {
					if_block = null;
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);

			if (~current_block_type_index) {
				if_blocks[current_block_type_index].d();
			}
		}
	};
}

// (20:0) <Popup isClosable="{true}" closePopup="{closePopup}">
function create_default_slot(ctx) {
	let popupheader;
	let t_1;
	let popupbody;
	let current;

	popupheader = new PopupHeader({
			props: {
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	popupbody = new PopupBody({
			props: {
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(popupheader.$$.fragment);
			t_1 = space();
			create_component(popupbody.$$.fragment);
		},
		m(target, anchor) {
			mount_component(popupheader, target, anchor);
			insert(target, t_1, anchor);
			mount_component(popupbody, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const popupheader_changes = {};

			if (dirty & /*$$scope*/ 16) {
				popupheader_changes.$$scope = { dirty, ctx };
			}

			popupheader.$set(popupheader_changes);
			const popupbody_changes = {};

			if (dirty & /*$$scope, $tsv, $purchaseTwoFactor*/ 19) {
				popupbody_changes.$$scope = { dirty, ctx };
			}

			popupbody.$set(popupbody_changes);
		},
		i(local) {
			if (current) return;
			transition_in(popupheader.$$.fragment, local);
			transition_in(popupbody.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(popupheader.$$.fragment, local);
			transition_out(popupbody.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(popupheader, detaching);
			if (detaching) detach(t_1);
			destroy_component(popupbody, detaching);
		}
	};
}

function create_fragment(ctx) {
	let popup;
	let current;

	popup = new Popup({
			props: {
				isClosable: true,
				closePopup: /*closePopup*/ ctx[2],
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(popup.$$.fragment);
		},
		m(target, anchor) {
			mount_component(popup, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const popup_changes = {};

			if (dirty & /*$$scope, $tsv, $purchaseTwoFactor*/ 19) {
				popup_changes.$$scope = { dirty, ctx };
			}

			popup.$set(popup_changes);
		},
		i(local) {
			if (current) return;
			transition_in(popup.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(popup.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(popup, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $purchaseTwoFactor;
	let $tsv;
	component_subscribe($$self, purchaseTwoFactor, $$value => $$invalidate(0, $purchaseTwoFactor = $$value));
	component_subscribe($$self, tsv, $$value => $$invalidate(1, $tsv = $$value));
	let { closeApplication } = $$props;
	setLoading(false);

	function closePopup() {
		toogleVisibilityConfirmPurchasePopup(false);
		closeApplication();
	}

	$$self.$$set = $$props => {
		if ('closeApplication' in $$props) $$invalidate(3, closeApplication = $$props.closeApplication);
	};

	return [$purchaseTwoFactor, $tsv, closePopup, closeApplication];
}

class ConfirmPurchase extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { closeApplication: 3 });
	}
}

export { ConfirmPurchase as default };
//# sourceMappingURL=ConfirmPurchase.svelte.js.map
